import styled from "styled-components";
import { MainSection } from "../../../components/01_config/MainStyles";
import { sizes } from "../../../components/01_config/Sizes";

const StatisticsWrapper = styled(MainSection)`
    margin-top: 0;
    padding: 40px 50px;
    align-items: center;
    color: white;
    font-weight: 600;
    background-color: black;
    @media(max-width: 800px) {
        // margin: ${sizes.sections_mob_margintop} ${sizes.sections_mob_marginsides};
    }
`

const BlockWrapper = styled.div`
    width: 150px;
    text-align: center;
`

const Numbers = styled.div`
    font-size: 3rem;
`

const Words = styled.div`

`

export { StatisticsWrapper, BlockWrapper, Numbers, Words }